import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import { Toggle } from '@hydra/common/components';

const useStyles = makeStyles({
  root: {
    display: 'flex'
  }
});

export const FormToggle = ({ disabled, value, onChange }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Toggle disabled={disabled} checked={value} onChange={onChange} />
    </div>
  );
};

FormToggle.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired
};

export default FormToggle;
